import script from "./ConsultationBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationBooking.vue?vue&type=script&setup=true&lang=js"

import "./ConsultationBooking.vue?vue&type=style&index=0&id=c98f5c84&scoped=true&lang=scss"

import exportComponent from "/var/local/jenkins-agent/data/agent/workspace/_Bitbucket_tvg-online-gui_master/tvg-online-ui/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c98f5c84"]])

export default __exports__